import { render } from "./Form.vue?vue&type=template&id=5d0b7362&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=5d0b7362&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5d0b7362"

export default script